module.exports = __webpack_public_path__ + "static/media/popcorn-sad.d09a7a45.png";